import { createLucideIcon } from 'lucide-react';
export const WalletIcon = createLucideIcon('wallet-icon', [
  [
    'path',
    {
      d: 'M -1.5 43 C-1.5 41.767 -1.5 41 -3.75 40.75',
      key: '1ub48h',
    },
  ],
  [
    'path',
    {
      d: 'M -2.5 42.5 L -4 40.5',
      key: 'u6k1no',
    },
  ],
  [
    'path',
    {
      d: 'M -3.5 36 L -3.5 45.75',
      key: '1va19z',
    },
  ],
  [
    'path',
    {
      d: 'M -3.5 39 L -3.5 29.25',
      key: '1qgixa',
    },
  ],
  [
    'path',
    {
      d: 'M -4.5 29.5 L -1.75 30.5',
      key: '80b2f5',
    },
  ],
  [
    'path',
    {
      d: 'M -5 43.5 C-5.425 43.5 4.75 36.5 -5.75 42.75',
      key: 'h2zbch',
    },
  ],
  [
    'path',
    {
      d: 'M -6.5 41.5 C3 42.5 -6.175 40.75 -5.75 40.75',
      key: '11zoh7',
    },
  ],
  [
    'path',
    {
      d: 'M -8 40 L 0.531 37.75',
      key: '1h5jei',
    },
  ],
  [
    'path',
    {
      d: 'M 1 41.5 C1 41.925 -14.5 41.25 0.25 42.25',
      key: '575j5i',
    },
  ],
  [
    'path',
    {
      d: 'M 16.875 3.0468 L 4.6875 6.2578',
      key: '1m0jzf',
    },
  ],
  [
    'path',
    {
      d: 'M 17.2266 2.9999 C17.1123 3.0029 16.9922 3.0175 16.875 3.0468',
      key: '9r7kx8',
    },
  ],
  [
    'path',
    {
      d: 'M 17.2266 2.9999 L 17.2266 2.9999',
      key: '1g2che',
    },
  ],
  [
    'path',
    {
      d: 'M 18.75 20.9999 C19.9834 20.9999 21 19.9833 21 18.7499',
      key: 'qjm28i',
    },
  ],
  [
    'path',
    {
      d: 'M 18.75 4.4999 C18.75 3.6562 18.0322 2.9882 17.2266 2.9999',
      key: '1qbcys',
    },
  ],
  [
    'path',
    {
      d: 'M 18.75 5.9999 L 18.75 4.4999',
      key: 'jww3x3',
    },
  ],
  [
    'path',
    {
      d: 'M 18.75 8.25 C19.175 8.25 20.5 8 21 9',
      key: '15zehx',
    },
  ],
  [
    'path',
    {
      d: 'M 2 41 L -11.5 41',
      key: 'r3nsnz',
    },
  ],
  [
    'path',
    {
      d: 'M 2.031 40 L -8 40',
      key: '1lbql8',
    },
  ],
  [
    'path',
    {
      d: 'M 21 18.7499 L 21 8.9999',
      key: '1x6pxg',
    },
  ],
  [
    'path',
    {
      d: 'M 3 18.7499 C3 19.9833 4.0166 20.9999 5.25 20.9999',
      key: '14rsrv',
    },
  ],
  [
    'path',
    {
      d: 'M 3 8.4374 L 3 18.7499',
      key: '1uolsg',
    },
  ],
  [
    'path',
    {
      d: 'M 4 39 L -0.25 41',
      key: '1v7fn8',
    },
  ],
  [
    'path',
    {
      d: 'M 4 8.5 L 18.75 8.25',
      key: 'e4dzbs',
    },
  ],
  [
    'path',
    {
      d: 'M 4.6875 6.2578 C3.7031 6.5156 3 7.4179 3 8.4374',
      key: '19vzyt',
    },
  ],
  [
    'path',
    {
      d: 'M 5.25 20.9999 L 18.75 20.9999',
      key: '1ank23',
    },
  ],
  [
    'path',
    {
      d: 'M16.875 12.7499C16.2539 12.7499 15.75 13.2538 15.75 13.8749C15.75 14.496 16.2539 14.9999 16.875 14.9999C17.4961 14.9999 18 14.496 18 13.8749C18 13.2538 17.4961 12.7499 16.875 12.7499Z',
      key: '1u0c2c',
    },
  ],
]);
